import { PricingSummaryResponseBuilder } from './PricingSummaryResponseBuilder';
import { CancellationResponseBuilder } from './CancellationResponseBuilder';
import { IBaseArgument } from './IBaseArgument';
import { BaseResponseBuilder } from './BaseResponseBuilder';

export class RepresentativeInfoResponseBuilder extends BaseResponseBuilder {
    constructor() {
        super('RepresentativeInfo');
    }
    public withActivityId = (shouldAsk: boolean = true) => {
        const args: IBaseArgument[] = [];

        if (shouldAsk) this.fields['activityId'] = this.initField(null, args);
        return this;
    }

    public withSupplierActivityCode = (shouldAsk: boolean = true) => {
        const args: IBaseArgument[] = [];

        if (shouldAsk) this.fields['supplierActivityCode'] = this.initField(null, args);
        return this;
    }

    public withActivityToken = (shouldAsk: boolean = true) => {
        const args: IBaseArgument[] = [];

        if (shouldAsk) this.fields['activityToken'] = this.initField(null, args);
        return this;
    }

    public withPricingSummary = (builder: PricingSummaryResponseBuilder, shouldAsk: boolean = true) => {
        const args: IBaseArgument[] = [];

        if (shouldAsk) this.fields['pricingSummary'] = this.initField(builder, args);
        return this;
    }

    public withCancellationPolicy = (builder: CancellationResponseBuilder, shouldAsk: boolean = true) => {
        const args: IBaseArgument[] = [];

        if (shouldAsk) this.fields['cancellationPolicy'] = this.initField(builder, args);
        return this;
    }

    public withConfirmMinutes = (shouldAsk: boolean = true) => {
        const args: IBaseArgument[] = [];

        if (shouldAsk) this.fields['confirmMinutes'] = this.initField(null, args);
        return this;
    }

    public withIsInstantConfirmation = (shouldAsk: boolean = true) => {
        const args: IBaseArgument[] = [];

        if (shouldAsk) this.fields['isInstantConfirmation'] = this.initField(null, args);
        return this;
    }
}
